// NOTA: mover esto al backend si hace falta manejar puestos dinamicamente
const puestosCalado = [
  { puesto: 'calle_1-2', nombrePuesto: 'Calle 1/2' },
  { puesto: 'calle_3-4', nombrePuesto: 'Calle 3/4' }
]

export function requestPuestosCalado () {
  return dispatch => {
    dispatch({ type: 'REQUEST_PUESTOS_CALADO' })
    return Promise.resolve(puestosCalado)
      .then(puestos => {
        dispatch({
          type: 'RECEIVE_PUESTOS_CALADO',
          puestosCalado: puestos
        })
      })
      .catch(err => err)
  }
};

export function setPuestoCalado (puestoCalado, nombrePuestoCalado) {
  return dispatch => {
    dispatch({ type: 'CAMBIAR_PUESTO_CALADO', puestoCalado, nombrePuestoCalado })
  }
};
